import React, {FC} from "react"
import {H2} from "@irati/ui/src/Typography"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {useTheme} from "@irati/ui/src/global/useTheme"

interface PriceProps {
  value?: number
  currencyCode: string
  state: string
  highlight?: boolean
}

const Price: FC<PriceProps> = ({value, currencyCode, state, highlight}) => {
  const theme = useTheme()
  if (value && state === "valid" && highlight) {
    return <H2 color={theme.colors.tertiary.g_600}>{formatCurrency({currencyCode, value})}</H2>
  } else if (value && state === "valid") {
    return <H2>{formatCurrency({currencyCode, value})}</H2>
  }

  return <H2 color="subdued">N/A</H2>
}

export default Price
